<div
  *ngIf="travelForm"
  [formGroup]="travelForm"
>
  <mable-heading
    heading="h2"
    headingStyle="h3"
    >Travel</mable-heading
  >
  <ng-container *ngIf="!isTravelSectionDisabled; else travelSectionDisabledTemplate">
    <!-- ENABLE TRAVEL RATE CHECKBOX -->
    <ion-item
      lines="none"
      class="ion-no-padding ion-margin-horizontal"
    >
      <ion-checkbox
        formControlName="includeTravelRate"
        data-testid="agreement-travel-form-travel-expense"
        slot="start"
        labelPlacement="end"
        justify="start"
      >
        <span class="ion-text-wrap"> Include a rate for travel using your vehicle during sessions. </span>
      </ion-checkbox>
    </ion-item>

    <p class="ion-margin-horizontal">
      Your client must agree to add a per kilometre rate for services. Talk to them before you add this to your
      agreement.
    </p>

    <!-- PER KM TRAVEL RATE -->
    <ng-container *ngIf="travelForm.value.includeTravelRate">
      <mable-input
        label="Per kilometre rate"
        class="ion-no-padding"
        icon="fa-dollar-sign-solid"
        [hasError]="travelForm.get('perKmTravelRate').showError()"
      >
        <p class="description">The Mable worker {{ currentSupportProviderFee }}% fee applies to this rate.</p>
        <ion-input
          type="text"
          class="ion-no-padding"
          formControlName="perKmTravelRate"
          (ionBlur)="validatePerKmRate()"
          aria-label="per kilometre rate"
        >
        </ion-input>
        <div class="warn">
          <p *ngIf="travelForm.controls.perKmTravelRate.errors?.required">Please enter the per kilometre rate</p>
          <p *ngIf="travelForm.controls.perKmTravelRate.errors?.pattern">Please enter a numeric value</p>
          <p *ngIf="travelForm.controls.perKmTravelRate.errors?.invalidPerKmRateErrorMessage">
            {{ travelForm.controls.perKmTravelRate.errors.invalidPerKmRateErrorMessage }}
          </p>
        </div>
        <p
          class="info"
          *ngIf="!travelForm.get('perKmTravelRate').showError()"
        >
          Before the Mable ({{ currentSupportProviderFee }}%) worker fee is deducted.
        </p>
      </mable-input>
      <div class="ion-margin-horizontal">
        <p>
          You negotiate the per kilometre rate with your client, however, the NDIS Price Guide states that the "NDIA
          considers up to ${{ ndiaPriceGuideTravelRate }} per km to be reasonable". Many plan manager organisations and
          Support at Home funding providers have an accepted range for transport in their payment systems. With the
          Mable client fee ({{ currentClientFee }}%) considered, an agreed rate of ${{ defaultPerKmRate }} per km (of
          which you will receive ${{ defaultPerKmNetRate }}, after the Mable support worker platform fee is applied ({{
            currentSupportProviderFee
          }}%)) will keep you within this accepted range and may prevent potential payment delays from these
          organisations.
        </p>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #travelSectionDisabledTemplate>
    <p class="ion-margin">
      Your client’s funding source does not allow for charging travel separately. Make sure your rate include all costs
      associated with delivering support services.
    </p>
  </ng-template>
  <mable-button
    category="link"
    href="https://mable.com.au/help_centre/travel-rates-on-mable/"
  >
    More info about charging for travel
  </mable-button>
</div>
